import request from '@/utils/request';

//新增
export function addOrder(data) {
  return request({
    url: '/car/order',
    method: 'post',
    data,
  });
}

//列表
export function getOrderList(data) {
  return request({
    url: '/car/order',
    method: 'get',
    params: data,
  });
}

export function exportExcel(data) {
  return request({
    url: '/car/order/exportExcel',
    method: 'get',
    params: data,
    responseType: 'blob',
  });
}
